// infinite scroll
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.pagination = this.dataset.pagination === 'true';
    this.productsContainer = this.querySelector(`[id^="${this.dataset.productsContainer}"]`);
    this.productsLoadButton = this.querySelector('[id^="infinityLoad-"]');
    this.loadingSpinner = this.querySelector('.js-infinity-load');
  }

  connectedCallback() {
    if(!this.pagination || !this.productsLoadButton) return;
    InfiniteScroll.initInfiniteScroll(this);
  }

  getUrl() {
    const currentUrl = window.location.href;
    const urlLast = currentUrl?.split("/").pop();
    const url = urlLast === this.dataset.handle ? `${currentUrl}?` : `${currentUrl}&`;

    return url;
  }

  static initInfiniteScroll(instance) {
    const productsToLoad = () => {
      instance.startLoading();
      instance.renderProducts(instance.getUrl());
    };

    instance.observer = new IntersectionObserver(entries => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        productsToLoad()
      }
    }, {
      root: null, // Observe relative to viewport
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.1 // Trigger when 10% visible
    });

    instance.observer.observe(instance.productsLoadButton);
  }

  async renderProducts(url) {
    const currentPageIndex = parseInt(this.dataset.currentPage);
    const requestedPageIndex = Math.min(currentPageIndex + 1, parseInt(this.dataset.maxPages));

    try {
      const response = await fetch(`${url}page=${requestedPageIndex}`);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const responseText = await response.text();
      if(currentPageIndex === requestedPageIndex) return;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const productlist = html.querySelector(`[id^="${this.dataset.productsContainer}"]`).children;

      if(!productlist) return;
      Array.from(productlist).forEach(productItem => {
        this.productsContainer.appendChild(productItem);
      });

    } catch (error) {
      console.error(error);
    } finally {
      this.stopLoading();
      this.loadingComplete();
      this.dataset.currentPage = requestedPageIndex;
      if (parseInt(this.dataset.maxPages) === requestedPageIndex) {
        this.productsLoadButton.classList.add('hidden');
        this.productsLoadButton.parentElement.remove();
      }
    }
  }

  startLoading() {
    this.productsLoadButton.classList.add('loading');
    this.loadingSpinner.classList.add('loading__spinner');
  }

  stopLoading() {
    this.productsLoadButton.classList.remove('loading');
    this.productsLoadButton.classList.remove('loading-complete');
  }

  loadingComplete() {
    this.productsLoadButton.classList.add('loading-complete');
    this.loadingSpinner.classList.remove('loading__spinner');
  }

  toggleLoading() {
    const loader = this.querySelector('[id^="infinityLoad-"]');
    const loadingSpinner = loader.querySelector('.js-infinity-load');
    loader.classList.contains('loading') ? loader.classList.remove('loading') : loader.classList.add('loading');
    loadingSpinner.classList.contains('loading__spinner') ? loadingSpinner.classList.remove('loading__spinner') : loadingSpinner.classList.add('loading__spinner');
  }
}

customElements.define('infinite-scroll', InfiniteScroll);

// facets wrapper
// function facetsWrapper() {
//   var facetsFields = document.querySelectorAll('.facets__form-vertical fieldset');
//   document.addEventListener('DOMContentLoaded', () => {
//     facetsFields.forEach((filed) => {
//       filed.style.overflowY = 'auto';
//       filed.style.maxHeight = `${filed.scrollHeight}px`;
//     });
//   })
// }

// facetsWrapper();

// collection view
class CollectionView extends HTMLElement {
  constructor() {
    super();
    this.viewButtons = this.querySelectorAll('.js-view-button');
    this.productsContainer = document.getElementById(this.dataset.productsContainer);

    if(!this.productsContainer) return;
    this.viewButtons?.forEach((button) => {
      button.addEventListener('click', () => {
        if(this.productsContainer.dataset.view === button.dataset.view) return;
        console.log(button.dataset.view);
        this.updateCartAttribute(button.dataset.view);
      });
    });
  }

  updateCollectionView(view) {
    this.productsContainer = document.getElementById(this.dataset.productsContainer);
    return this.productsContainer.dataset.view = view;
  }

  updateCartAttribute(view) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: {},
        attributes: {
          product_view: view
        }
      })
    })
      .then(response => response.json())
      .then(data => {})
      .catch(error => {
        console.error('Error updating collection view:', error);
      })
      .finally(() => this.updateCollectionView(view));
  }
}

customElements.define('collection-view', CollectionView);

// prev page button
class PrevPageElement extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      window.history.back();
    });
  }
}

customElements.define('prev-page', PrevPageElement);

// oder tabs
class orderTabs extends HTMLElement {
  constructor() {
    super();

    let tabAll = document.querySelectorAll(".order-tab-button");
    let orderRow = document.querySelectorAll(".js-order-table--row");

    this.addEventListener('click', (event) => {
      event.preventDefault();
      let targetID = event.target;
      let getData = targetID.getAttribute("id");

      tabAll.forEach((tabLink) => {
        tabLink.classList.remove("tab-active");
        targetID.classList.add("tab-active");
      });

      orderRow.forEach((orderContent) => {
        let dataStatus = orderContent.getAttribute("data-status");

        if (getData !== dataStatus){
          orderContent.classList.add("hidden");
          if (getData === "all-order"){
            orderContent.classList.remove("hidden")
          }
        }else{
          orderContent.classList.remove("hidden")
        }
      });
    });
  }
}

customElements.define('order-tabs', orderTabs);

// accordion item
class AccordionComponents extends HTMLElement {
  constructor() {
    super();

    this.expanded = this.getAttribute('aria-expanded');
    this.content = this.querySelector('.js-accordion-content');

    this.addEventListener('click', this.toggleAccordion.bind(this));
    (this.getAttribute('aria-expanded') === 'true') ? this.content.style.maxHeight = this.content.scrollHeight + "px" : this.content.style.maxHeight = null;
  }

  toggleAccordion() {
    this.expanded = this.getAttribute('aria-expanded');
    this.content = this.querySelector('.js-accordion-content');

    this.setAttribute('aria-expanded', (this.expanded === 'false').toString());
    (this.expanded === 'false') ? this.content.style.maxHeight = this.content.scrollHeight + "px" : this.content.style.maxHeight = null;
  }
}

customElements.define('accordion-item', AccordionComponents);

// custom eye
class PasswordEyeComponents extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.content = this.querySelector('[data-eyeSwitch]');

    this.content.addEventListener('click', () => {
      this.expanded = this.getAttribute('aria-expanded');

      this.setAttribute('aria-expanded', (this.expanded === 'false').toString());
      (this.expanded === 'false') ? this.input.type = "text" : this.input.type = "password";
    });
  }
}

customElements.define('custom-eye', PasswordEyeComponents);

// disable submit
document.addEventListener('DOMContentLoaded', function() {
  var addressForms = document.querySelectorAll('[id^="address_form_"]');

  addressForms.forEach(form => {
    let submitButton = form.querySelector('#buttonSubmit');
    let requiredInputs = form.querySelectorAll('input[required]');

    function checkInputs(input) {
      if (input.value.trim() === '') {
        input.parentElement.classList.add('unfilled');
      } else {
        input.parentElement.classList.remove('unfilled');
      }
    }

    requiredInputs.forEach(function(input) {
      input.addEventListener('input', function() {
        checkInputs(input);
        updateSubmitButton();
      });

      // input.addEventListener('focus', function() {
      //   checkInputs(input);
      // });

      input.addEventListener('blur', function() {
        checkInputs(input);
        updateSubmitButton();
      });
    });

    submitButton.addEventListener('click', function() {
      if (!submitButton.disabled) {
        requiredInputs.forEach(function(input) {
          checkInputs(input);
        });
      }
    });

    function updateSubmitButton() {
      var allInputsFilled = true;
      requiredInputs.forEach(function(input) {
        if (input.value.trim() === '') {
          allInputsFilled = false;
        }
      });
      submitButton.disabled = !allInputsFilled;
    }
  });
});

// window history
function windowHistory() {
  const currentPageUrl = window.location.href;
  let historyArray = JSON.parse(localStorage.getItem('historyUrls')) || [];
  historyArray = historyArray.filter(url => url !== currentPageUrl);
  historyArray.unshift(currentPageUrl);
  if (historyArray.length > 5) {
    historyArray.pop();
  }
  localStorage.setItem('historyUrls', JSON.stringify(historyArray));

  const returToInput = document.querySelector('input[name="return_to"]');
  if(returToInput && window.location.pathname.includes('login')) {
    returToInput.value = historyArray[1].replace(window.location.origin, "");
  }
}
windowHistory();